/** 是否按 4G 表处理：后端通讯类型为 4G，或当前/厂商表号以 YJ 开头（不区分大小写） */
export function isDevice4GMeter(device) {
  if (!device) return false;
  if (Number(device.communication_type) === 0) return true;
  const yjPrefix = (s) => String(s ?? '').trim().toUpperCase().startsWith('YJ');
  return yjPrefix(device.current_meter_no) || yjPrefix(device.factory_meter_no);
}

/**
 * 读取设备「所属厂家」原始值（管理端列表接口为 json manufacturer，个别环境可能大小写不一致）
 */
export function getDeviceManufacturerCode(device) {
  if (!device || typeof device !== 'object') return '';
  const raw = device.manufacturer ?? device.Manufacturer ?? '';
  return String(raw)
    .replace(/^\uFEFF/, '')
    .trim();
}

/** 是否 ZT 厂家（水表列表里用于隐藏 YJ 同款远程按钮）；仅看厂家字段，大小写不敏感 */
export function isZtManufacturer(device) {
  const code = getDeviceManufacturerCode(device);
  if (!code) return false;
  if (code.toUpperCase() === 'ZT') return true;
  if (code === '厂家一') return true;
  return false;
}

/**
 * 水表列表专用：远程 MQTT 补量 / 55 计量系数 仅适用于非 ZT 厂家（YJ 同协议）的远程表。
 */
export function isWaterMeterYjRemoteOpsEnabled(device) {
  if (!device) return false;
  if (isZtManufacturer(device)) return false;
  return isDevice4GMeter(device);
}
